import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'mt-icon-chevron',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './icon-chevron.ui-component.html',
  styleUrl: './icon-chevron.ui-component.scss',
})
export class IconChevronUiComponent {}
